import ATableAccess from "./aTableAccess";

class CostUnitAccess extends ATableAccess {}

export default CostUnitAccess;
